import type { MapCardFieldKey } from '@/stores/persistentTableStore';

const ADDRESS_PART_KEYS: MapCardFieldKey[] = [
  'address1',
  'address2',
  'city',
  'stateSubdivision',
  'zipPostal',
  'country',
];

/**
 * Splits API `physical_address` (comma-separated, same order as {@see Address::getDisplayStringAttribute})
 * into semantic slots. When optional fields are omitted server-side, later segments shift — labels are best-effort.
 */
export function parsePhysicalAddressParts(raw: string): Record<
  (typeof ADDRESS_PART_KEYS)[number],
  string | undefined
> {
  const segments = raw
    .split(/,\s+/)
    .map((segment) => segment.trim())
    .filter(Boolean);
  const out: Partial<Record<(typeof ADDRESS_PART_KEYS)[number], string>> = {};
  for (let i = 0; i < Math.min(segments.length, ADDRESS_PART_KEYS.length); i++) {
    const key = ADDRESS_PART_KEYS[i];
    out[key] = segments[i];
  }
  return out as Record<(typeof ADDRESS_PART_KEYS)[number], string | undefined>;
}
